import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    form: {
        margin: ".5rem 0 1.5rem",
    },
    grid: {
        backgroundColor: "#f3f3f3",
        padding: "4rem 2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    btn: {
        marginLeft: ".5rem",
    },
    formSubtext: {
        textAlign: "center",
    },
}));
